<template>
    <div class="rounded-md bg-white shadow-card  flex flex-col px-8 py-3 ">
        <div class="flex justify-between items-center">
            <h4 class="text-xl normal font-bold">{{ title }}</h4>
            <span
                class="bg-blue-900 rounded-lg flex items-center justify-center"
            >
                <slot name="icon"></slot>
            </span>
        </div>

        <slot></slot>

        <!-- <div v-else>
            <div class="flex justify-center items-center min-h-7 gap-7 h-12">
                <span
                    ><svg
                        width="36"
                        height="100%"
                        viewBox="0 0 36 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M35.5706 46.8589H31.1353V42.4309C31.1353 40.6693 30.4344 38.9799 29.1867 37.7342C27.939 36.4886 26.2468 35.7888 24.4824 35.7888H11.1765C9.41202 35.7888 7.71982 36.4886 6.47215 37.7342C5.22448 38.9799 4.52355 40.6693 4.52355 42.4309V46.8589H0.0882568V42.4309C0.0882568 39.4949 1.25648 36.6792 3.33593 34.6032C5.41537 32.5271 8.23571 31.3608 11.1765 31.3608H24.4824C27.4232 31.3608 30.2435 32.5271 32.3229 34.6032C34.4024 36.6792 35.5706 39.4949 35.5706 42.4309V46.8589ZM17.8294 26.9328C16.0821 26.9328 14.3518 26.5892 12.7375 25.9216C11.1231 25.254 9.65632 24.2755 8.42075 23.042C7.18519 21.8085 6.20508 20.3441 5.5364 18.7324C4.86772 17.1207 4.52355 15.3933 4.52355 13.6488C4.52355 11.9043 4.86772 10.1769 5.5364 8.5652C6.20508 6.95351 7.18519 5.48909 8.42075 4.25555C9.65632 3.02201 11.1231 2.04352 12.7375 1.37593C14.3518 0.708348 16.0821 0.364746 17.8294 0.364746C21.3584 0.364746 24.7428 1.76431 27.2381 4.25555C29.7335 6.74679 31.1353 10.1256 31.1353 13.6488C31.1353 17.1719 29.7335 20.5508 27.2381 23.042C24.7428 25.5332 21.3584 26.9328 17.8294 26.9328ZM17.8294 22.5048C20.1821 22.5048 22.4383 21.5718 24.1019 19.9109C25.7654 18.2501 26.7 15.9975 26.7 13.6488C26.7 11.3 25.7654 9.04745 24.1019 7.38663C22.4383 5.7258 20.1821 4.79276 17.8294 4.79276C15.4768 4.79276 13.2205 5.7258 11.557 7.38663C9.89342 9.04745 8.95885 11.3 8.95885 13.6488C8.95885 15.9975 9.89342 18.2501 11.557 19.9109C13.2205 21.5718 15.4768 22.5048 17.8294 22.5048Z"
                            fill="#2FA97E"
                        /></svg
                ></span>
                <div class="flex">
                    <span
                        class="h-9 w-9 rounded-full bg-green-900 absolute opacity-25"
                    ></span>
                    <span
                        class="text-6xl font-lato font-semibold text-green-900 z-10"
                        >{{ nbMoyensHumain || 0 }}</span
                    >
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    created() {
        // if (this.montantSolliticite) {
        // } else if (this.secteurDacitivite) {
        //     // this.secteurDacitivite.forEach((nb, secteur, index) => {
        //     //     if (index >= 5) break;
        //     //     this.chartOptions.labels.push(secteur);
        //     //     this.series.push(nb);
        //     //     console.log(secteur + " " + nb);
        //     // });
        //     this.secteurDacitivite[Symbol.iterator] = function*() {
        //         yield* [...this.entries()].sort((a, b) => b[1] - a[1]);
        //     };
        //     let counter = 0;
        //     let autreValue = 0;
        //     for (let [key, value] of this.secteurDacitivite) {
        //         if (counter < 6) {
        //             this.chartOptions.labels.push(
        //                 key.length > 20 ? key.slice(0, 20) + "..." : key
        //             );
        //             this.series.push(value);
        //         } else {
        //             autreValue += value;
        //         }
        //         counter++;
        //     }
        //     this.chartOptions.labels.push("Autres");
        //     this.series.push(autreValue);
        // }
    },
    props: {
        title: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    width: 380,
                    type: "pie"
                },
                labels: [],
                colors: ["#9fb7c4", "#568297", "#265e7a", "#0a354b", "#041720"],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: "bottom"
                            }
                        }
                    }
                ]
            }
        };
    }
};
</script>

<style></style>
